<template>
    <div class="info-box">
        <div class="infos flex justify-between items-center">
            <p class="text-grey text-base">{{ label }}</p>
            <p v-if="value != ''" class="text-black font-semibold text-base text-ellipsis">{{ value }}</p>
            <slot v-else></slot>
        </div>
        <div v-if="sep" class="h-px bg-gray-100 my-5"></div>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true
            },
            value: {
                type: String,
                default: ''
            },
            sep: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                
            }
        },
    }
</script>
